<template>
  <div class="c-breadcrumbs">
    <div class="container">
      <ul class="c-breadcrumbs__list">
        <li v-for="(breadcrumb, idx) in breadcrumbs" :key="idx" class="c-breadcrumbs__list-item">
          <router-link :to="breadcrumb.to" class="c-breadcrumbs__list-link">
            {{ $t(breadcrumb.name, breadcrumb.params || {}) }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreadcrumbs } from '@/core';

const { breadcrumbs } = useBreadcrumbs();
</script>
